import { useMutation, useQueryClient } from '@tanstack/react-query';

import { displayToastError } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateRoleRelatedQueries } from '@/modules/common/utils/query-invalidation';

import { deleteRole } from '../../api/roles.api';

/**
 * Hook to delete a role.
 * Handles mutation, cache invalidation for roles and related team member queries.
 *
 * @returns TanStack Query mutation for deleting a role
 */
export const useDeleteRole = () => {
  const queryClient = useQueryClient();
  const { getErrorMessage } = useApiError();

  return useMutation({
    mutationFn: deleteRole,
    onSuccess: async () => {
      // Invalidate role and team member queries
      await invalidateRoleRelatedQueries(queryClient);
    },
    onError: (error: unknown) => {
      displayToastError(getErrorMessage(error, true));
    },
  });
};
